import SystemLink, { type ISystemLinkProps } from './SystemLink';
import { splitLinkAddresses } from './splitLinkAddresses';

/**
 * Значение URL-поля с одним или несколькими адресами. Подписи сопоставляются построчно,
 * только если их столько же, сколько адресов; иначе каждая ссылка подписывается сама
 * (названием документа, доменом и т. п.).
 */
const SystemLinkList = ({ href, caption = '', ...props }: ISystemLinkProps) => {
    const addresses = splitLinkAddresses(href);
    if (addresses.length < 2) return <SystemLink href={href} caption={caption} {...props} />;
    const captions = splitLinkAddresses(caption);
    const paired = caption !== href && captions.length === addresses.length;
    return (
        <span className="system-link-list">
            {addresses.map((address, index) => (
                <SystemLink
                    key={`${index}:${address}`}
                    href={address}
                    caption={paired ? captions[index] : address}
                    {...props}
                />
            ))}
        </span>
    );
};

export default SystemLinkList;
